import { useState, useEffect } from 'react';
import { platformApi } from '../api/apiClient';

/**
 * Whether email login/registration is enabled platform-wide. Reads the public
 * platform settings once (module-level cache shared across all callers) so the
 * customer, business-owner and admin auth screens can hide the email option.
 *
 * Returns `null` while loading, then a boolean. Callers should treat any
 * non-true value as "email disabled" (fail safe to the requested default).
 */
let _cache = null;       // boolean once resolved
let _inflight = null;    // de-dupes concurrent fetches
const _subs = new Set();

export function useEmailAuthEnabled() {
  const [val, setVal] = useState(_cache);

  useEffect(() => {
    if (_cache !== null) { setVal(_cache); return; }
    _subs.add(setVal);
    if (!_inflight) {
      _inflight = platformApi.getSettings()
        .then(r => { _cache = !!r.data?.emailAuthEnabled; })
        .catch(() => { _cache = false; })
        .finally(() => { _subs.forEach(fn => fn(_cache)); _subs.clear(); _inflight = null; });
    }
    return () => { _subs.delete(setVal); };
  }, []);

  return val;
}
